import React,{useState, useEffect,useReducer} from 'react';
import "./css/NameChangePopup.css";


function NoUserFoundPopup(props) {


     const close = (event) => {  
          event.preventDefault();
          if(event.target === event.currentTarget) {
               //close the whole popup with the function() in the parent
               props.setNoUserPopup(false);
          }        
     }

     if(props.message == "userExists"){
          var text = 'This email is already in use:';
     }
     else if(props.message == "noUser"){
          var text = 'No user was found with the email:';
     }


     return (
          <div className='nameChangePopupWide' onClick={close}>
               <div className='container'>
                    <div className='center'>
                         <p>{text} <span>{props.email}</span></p>
                         <button onClick={close}>Close</button>
                    </div>
               </div>
          </div>
     )
}

export default NoUserFoundPopup
